<template>
  <div class="choose-user-header">
    <b-row align-h="between" class="flex-grow-1">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              v-model.trim="form.searchKey"
              type="search"
              :placeholder="
                $l('INDEX.form_label_choose_sys_user') || '姓名/电话/邮箱 搜索...'
              "
              @keyup.enter="query"
            />
            <b-input-group-append>
              <b-button variant="primary" size="sm" @click="query">
                <i class="fa fa-search" />
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <div class="checked-count">
      <span class="label-text">{{ $l('tips_selector_selected') || '已选' }}</span>
      <span class="label-checked-count">{{ checkedCount }}</span>
      <span class="label-text">
        {{ $l('tips_selector_selected_person') || '人' }}
      </span>
    </div>
  </div>
</template>

<script>
const initForm = {
  searchKey: '',
  userStatusList: ['Y'],
}

export default {
  props: {
    checkedCount: { type: Number, default: 0 },
  },
  data() {
    return {
      form: { ...initForm },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) this.$emit('reset')

      this.$emit('query', this.form)
    },
    reset() {
      this.form = { ...initForm }
    },
  },
}
</script>

<style lang="scss" scoped>
.choose-user-header {
  display: flex;
  align-items: center;
  padding: 14px 0;
}
.checked-count {
  display: flex;
  align-items: center;
}
.label-text {
  font-size: 14px;
  color: #8f97ad;
}
.label-checked-count {
  margin: 0 8px;
  color: #071437;
  font-size: 14px;
}
</style>
